<template>
  <div>To be implement later</div>
</template>

<script>
export default {
  created() {
    this.$router.push({
      name: 'TemplateCollectionDetails',
      params: {
        id: 1,
      },
    })
  },
}
</script>